// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular.json`.

import { ENDPOINTS } from './endpoints';

export const environment = {
	production: false,
	httpsRedirect: false,
	apiRoot: 'http://localhost:3000/',
	socketRoot: 'http://localhost:3000/',
	reportRoot: 'http://localhost:3004/',
	endpoints: ENDPOINTS,
	sso: {
		IBM:
			{	client_id: '',
				authorization_url: '',
				logout_url: ''},
		NonIBM:
			{
				ibmid_client_id: '',
				ibmid_authorization_url: '',
				ibmid_logout_url:''
			}		
	}
};
